module.exports = __webpack_public_path__ + "static/media/wzory_10.7bfeed43.pdf";